import React, { useId } from "react";
import { Button, Modal } from "../../components/common";

interface Props {
  open: boolean;
  count: number;
  filtered: boolean;
  busy: boolean;
  onCancel: () => void;
  onDownload: () => void;
}

export default function RosterExportDialog({
  open,
  count,
  filtered,
  busy,
  onCancel,
  onDownload,
}: Props) {
  const id = useId();
  return (
    <Modal
      activeModal={open}
      onClose={() => {
        if (!busy) onCancel();
      }}
      hideHeader
      noFade
      dialogClass="w-full max-w-lg mx-4"
    >
      <section role="dialog" aria-modal="true" aria-labelledby={id}>
        <h2 id={id} className="text-xl font-semibold mb-4">
          Export staff roster
        </h2>
        <p className="text-sm text-gray-700 mb-6">
          Export {filtered ? "" : "all "}
          {count} staff as CSV — one row per person per course; staff with no
          course are included once. Your current search or filter applies; every
          page is included.
        </p>
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" disabled={busy} onClick={onCancel}>
            Cancel
          </Button>
          <Button disabled={busy} onClick={onDownload}>
            {busy ? "Downloading CSV…" : "Download CSV"}
          </Button>
        </div>
      </section>
    </Modal>
  );
}
